export const RESULTS_PATH = "/results";

export function isResultsPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, "") === RESULTS_PATH;
}
